// Utils
import { getFullImagePath } from "~utils/utils"
import { createDropdownValue } from "~utils/dropdown"
import { GetStockExchangeByCode } from "~utils/stockExchanges"
import {
  getCountryByCode,
  getRegionByCountryAndCode,
} from "~utils/countryRegionData"

// Shapes
import { LocationShape } from "~shapes/location"
import { CompanyShape } from "~shapes/company"

export const step1DefaultValues = () => {
  return {
    defaultValues: {
      country: createDropdownValue("United States", "US"),
    },
  }
}

export const step1PrefillValues = (company: CompanyShape) => {
  const location = company.location as LocationShape

  const region = getRegionByCountryAndCode(location.country, location.state)
  const country = getCountryByCode(location.country)
  const exchange = GetStockExchangeByCode(company.exchange)

  return {
    city: location.city,
    code: company.code,
    name: company.name,
    state: "",
    color: company.color ? `#${company.color}` : null,
    region: region ? createDropdownValue(region.name, region.code) : null!,
    symbol: company.symbol,
    country: country ? createDropdownValue(country.name, country.code) : null!,
    zipCode: location.postal,
    exchange: exchange
      ? createDropdownValue(exchange.shortName, exchange.shortName)
      : null!,
    description: company.description,
  }
}

export const step2PrefillValues = (company: CompanyShape) => ({
  contactName: company.contacts?.[0]?.name,
  contactEmail: company.contacts?.[0]?.email,
  contactPhone: company.contacts?.[0]?.phone,
})

export const step3PrefillValues = (company: CompanyShape) => ({
  logo: company.logo ? getFullImagePath(company.logo) : null,
  cover: company.cover ? getFullImagePath(company.cover) : null,
})

export const step4PrefillValues = (company: CompanyShape) => ({
  about: company.about,
})
